/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FeedResponse } from '../../models/feed-response';
import { LinkType } from '../../models/link-type';
import { PostPillCategory } from '../../models/post-pill-category';
import { TrendingType } from '../../models/trending-type';

export interface GetFeed$Params {
  lastDate?: string;
  limit?: number;
  search?: string;
  categoryId?: number;
  companyCategoryId?: number;
  companySizeId?: number;
  countryId?: number;
  startPeriodDate?: string;
  endPeriodDate?: string;
  trendingType?: TrendingType;
  isFollowing?: boolean;
  companyTagId?: number;
  departmentId?: number;
  activityTypeValue?: number;
  showNetwork?: boolean;
  networkLinkType?: LinkType;
  postPillCategory?: PostPillCategory;
}

export function getFeed(http: HttpClient, rootUrl: string, params?: GetFeed$Params, context?: HttpContext): Observable<StrictHttpResponse<FeedResponse>> {
  const rb = new RequestBuilder(rootUrl, getFeed.PATH, 'get');
  if (params) {
    rb.query('lastDate', params.lastDate, {});
    rb.query('limit', params.limit, {});
    rb.query('search', params.search, {});
    rb.query('categoryId', params.categoryId, {});
    rb.query('companyCategoryId', params.companyCategoryId, {});
    rb.query('companySizeId', params.companySizeId, {});
    rb.query('countryId', params.countryId, {});
    rb.query('startPeriodDate', params.startPeriodDate, {});
    rb.query('endPeriodDate', params.endPeriodDate, {});
    rb.query('trendingType', params.trendingType, {});
    rb.query('isFollowing', params.isFollowing, {});
    rb.query('companyTagId', params.companyTagId, {});
    rb.query('departmentId', params.departmentId, {});
    rb.query('activityTypeValue', params.activityTypeValue, {});
    rb.query('showNetwork', params.showNetwork, {});
    rb.query('networkLinkType', params.networkLinkType, {});
    rb.query('postPillCategory', params.postPillCategory, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FeedResponse>;
    })
  );
}

getFeed.PATH = '/api/feed';
